import React from 'react'
import { Link } from 'react-router-dom'
import "./Contact.css"

const Contact = () => {
  return (
    <div className="contact">
      <div className="contact_top">
        <div className="contact__top">
          <p className='contact__top_p'>CONTACT TO ACADEMY</p>
          <div className="contact__top__btn-group">
            <Link to="/" className='about__top_btn'>Home </Link>
            <span>&nbsp;/&nbsp;</span>
            <p className='contact__top_a'>Contact</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact